import { joinChannel } from './ws-actions';

export const emitBlogOpened = () => joinChannel('blog');

export const POST_PUBLISHED = 'post/PUBLISHED';
export const UPDATE_POST_COUNTERS = 'post/UPDATE_POST_COUNTERS';

export const updatePostCounters = (payload) => (dispatch) =>
  dispatch({
    type: UPDATE_POST_COUNTERS,
    payload,
  });
